import { render, staticRenderFns } from "./DeskCompilation.vue?vue&type=template&id=226d8b9c&scoped=true&"
import script from "./DeskCompilation.vue?vue&type=script&lang=ts&"
export * from "./DeskCompilation.vue?vue&type=script&lang=ts&"
import style0 from "./DeskCompilation.vue?vue&type=style&index=0&id=226d8b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226d8b9c",
  null
  
)

export default component.exports